export const getStepNumberFromFlowSteps = (steps, { path } = {}) => {
  if (!steps || steps.length === 0) {
    return 0;
  }

  const stepMap = {};
  for (const step of steps) {
    // Skip steps that are supposed to be excluded from the progress indicator.
    if (step.extraProps && step.extraProps.excludeFromProgressIndicator) {
      continue;
    }
    stepMap[step.path] = step;
  }

  let maxStep = 0;
  steps[0].depth = 1;
  const queue = [steps[0]];
  while (queue.length) {
    const node = queue.shift();
    if (!path || (path && path === node.path)) {
      maxStep = Math.max(maxStep, node.depth);
    }

    const childrenKeys = Array.isArray(node.next) ? node.next : [{ path: node.next }];
    for (const { path } of childrenKeys) {
      const newNode = stepMap[path];
      if (newNode) {
        newNode.depth = node.depth + 1;
        queue.push(newNode);
      }
    }
  }

  return maxStep;
};
